// extracted by mini-css-extract-plugin
module.exports = {"notes":"styles_notes__1zMH_","notes__textarea":"styles_notes__textarea__2Xkn3"};